import { Component, inject } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';
import { WarehouseMaterialComponent } from '../warehouse-material.component';

@Component({
    selector: 'app-warehouse-material-operations-dialog-list',
    templateUrl: './warehouse-material-operation-dialog-list.component.html',
    styleUrl: './warehouse-material-operation-dialog-list.component.scss',
    imports: [
        WarehouseMaterialComponent,
    ],
    providers: [
        FolderGlobalStore,
    ],
})
export class WarehouseMaterialOperationDialogListComponent extends BaseDialogComponent {

    protected readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setDialogComponent(this);
    }
}
